import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
var date = new Date();

var DocumentDate = /*#__PURE__*/function (_Vue) {
  _inherits(DocumentDate, _Vue);

  var _super = _createSuper(DocumentDate);

  function DocumentDate() {
    var _this;

    _classCallCheck(this, DocumentDate);

    _this = _super.call(this);
    _this.currentMonth = date.getMonth() + 1;
    _this.currentYear = date.getFullYear();
    return _this;
  }

  _createClass(DocumentDate, [{
    key: "date",
    value: function date(item) {
      return this.selectMonth === item && this.selectYear.toString() === this.year;
    }
  }, {
    key: "handleSelectDate",
    value: function handleSelectDate(year, month) {}
  }, {
    key: "handleActiveItemChange",
    value: function handleActiveItemChange(year) {}
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.currentYear.toString() !== this.year) {
        this.currentMonth = 12;
      }
    }
  }]);

  return DocumentDate;
}(Vue);

__decorate([Prop({
  type: String
})], DocumentDate.prototype, "activeItem", void 0);

__decorate([Prop({
  type: Number
})], DocumentDate.prototype, "yearCount", void 0);

__decorate([Prop({
  type: Object
})], DocumentDate.prototype, "monthCount", void 0);

__decorate([Prop({
  type: String
})], DocumentDate.prototype, "year", void 0);

__decorate([Prop({
  type: Number
})], DocumentDate.prototype, "selectMonth", void 0);

__decorate([Prop({
  type: Number
})], DocumentDate.prototype, "selectYear", void 0);

__decorate([Emit('handleSelectDate')], DocumentDate.prototype, "handleSelectDate", null);

__decorate([Emit('handleActiveItemChange')], DocumentDate.prototype, "handleActiveItemChange", null);

DocumentDate = __decorate([Component], DocumentDate);
export default DocumentDate;